module.exports = __webpack_public_path__ + "img/imago.17bcdab5.png";